<template>
    <div class="tag" :style="tagStyle">
        <img class="tag_icon" src="@/assets/icons/icon_tag.png" alt="">
        {{text}}
    </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({})
export default class TagComponent extends Vue{
    @Prop({default:''})
    text

    @Prop({default:'#000000'})
    background

    @Prop({default:'FFFFFF'})
    color

    @Prop({default:null})
    noRadius

    get tagStyle(){
        let style = {
            color: this.color,
            background: this.background
        }
        if(this.noRadius){
            style[`border-${this.noRadius}-radius`] = 0
        }
        return style
    }
}
</script>
<style lang="less" scoped>
    .tag{
        font-size: 1.6rem;
        height: 2.6rem;
        border-top-right-radius: 1.3rem;
        border-bottom-right-radius: 1.3rem;
        border-bottom-left-radius: 1.3rem;
        border-top-left-radius: 1.3rem;
        display: inline-flex;
        align-items: center;
        padding: 0 1.3rem;
        white-space: nowrap;
        // width: auto !important;
    }
    .tag_icon{
        width: 1.3rem;
        height: 1.2rem;
    }
</style>